import styled from 'styled-components';

// Definindo estilos para a tabela
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 18px;
`;

export const Th = styled.th`
  border: 2px solid black;
  padding: 8px;
  text-align: center;
`;

export const Td = styled.td`
  border: 2px solid black;
  padding: 8px;
  text-align: center;
`;

export const Container = styled.div`
  font-size: 18px;

`;